<template>
  <div>
    <SmartProgressBar
      :tracked_request="$app.upload_req"
      @finished="$app.upload_req = null"
    />

    <div
      class="project_base_view"
      :class="{ project_base_view_no_tree: !$ui.project_tree_keep_open }"
    >
      <SelectionBreadCrumb />
      
      <!-- <ProjectTreeIndicator
      v-if="$ui.tight_mode && !$ui.project_tree_keep_open"
      /> -->
      <ProjectTree v-if="$ui.project_tree_keep_open" :width="tree_width" />

      <!-- Lives here rather than inside the tree so it can be its own grid column,
           at the edge between the panes instead of behind the tree's scrollbar -->
      <Resizer
        v-if="$ui.project_tree_keep_open"
        v-model="tree_width"
        :min="250"
        :max="400"
      />

      <div :class="$ui.project_tree_keep_open ? 'mainpage' : 'mainpage_prj_tree_closed'">
        <router-view :key="$route.fullPath"></router-view>
        
      </div>
    </div>
    <NotesAndErrorsPanel class="notes-errors-fixed" />
  </div>
</template>

<script>
import ProjectTree from "@/components/prjtree/ProjectTree";
import ProjectTreeIndicator from "@/components/prjtree/ProjectTreeIndicator";

export default {
  name: "ProjectBaseView",
   components: {
    ProjectTree,
    // ProjectTreeIndicator
  },
  data() {
    return {
      show_tree: false,
      // Owned here because the resize handle is a sibling of the tree, not a child
      tree_width: 275
    };
  },

  mounted() {
    if (this.$app.sltd.project != null) {
      window.document.title = `${this.$app.sltd.project.name} | ${
        this.$txt.product_name
      }`;
    }
  }
};
</script>

<style>
.notes-errors-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: #fff;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
}
.wm_resizer {
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 2;
  grid-row-end: 3;
}
.mainpage {
  overflow-y: scroll;
  overflow-x: auto;
  min-width: 0;
  grid-column-start: 3;
  grid-column-end: 4;
  grid-row-start: 2;
  grid-row-end: 3;
}
.mainpage_prj_tree_closed {
  overflow-y: scroll;
  overflow-x: auto;
  min-width: 0;
  grid-column-start: 1;
  grid-column-end: -1;
  grid-row-start: 2;
  grid-row-end: 3;
}
.project_base_view.project_base_view_no_tree {
  grid-template-columns: minmax(0, 1fr);
}

.wm_centered_icon {
  padding: 20px;
}
</style>
